module.exports = __webpack_public_path__ + "img/zoom-out.c67054c8.svg";